import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FamilyCentredPrivateGpCare from "./sections/FamilyCentredPrivateGpCare";
import PartnersInProgress from "./sections/PartnersInProgress";
import OurCoreMission from "./sections/OurCoreMission";
import OurDirections from "./sections/OurDirections";
import ServingCoralSprings from "./sections/ServingCoralSprings";
import ReadyForADeviceUpgrade from "./sections/ReadyForADeviceUpgrade";
import VendorTrust from "./sections/VendorTrust";
import FooterHub from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FamilyCentredPrivateGpCare />
      <PartnersInProgress />
      <OurCoreMission />
      <OurDirections />
      <VendorTrust />
      <ServingCoralSprings />
      <ReadyForADeviceUpgrade />
      <FooterHub />
    </div>;
}